module.exports = __webpack_public_path__ + "img/3.e3c573d9.png";